module.exports = __webpack_public_path__ + "static/media/mask.ea29898f.svg";